import { Checkbox } from '@trackman/web-shared-components';
import { observer } from 'mobx-react-lite';

type Props = {
  data: { pga: boolean; lpga: boolean };
};

export const TourAveragesSettings = observer(({ data }: Props) => {
  return (
    <div className='admin-edit-section'>
      <h2>Tour Averages display settings</h2>
      <div className='checkboxes-container'>
        <Checkbox label='PGA' onChange={() => (data.pga = !data.pga)} checked={data.pga} />
        <Checkbox label='LPGA' onChange={() => (data.lpga = !data.lpga)} checked={data.lpga} />
      </div>
    </div>
  );
});

export default TourAveragesSettings;
